var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchSimple',{attrs:{"value":_vm.$route.query.search},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }